const isProd = true;

export const apiEndpoint = isProd ? 'https://backend.yafl.dk' : 'http://localhost:8000';
